const params = {
  apiUrl: "https://api.enay-digital.ru",
  backendUrl: "https://enay-digital.ru",
};
export default params;
